import { FC } from 'react'
import styles from './BestWayToWakeUp.module.scss'
import { BestWayToWakeUpProps } from './types'
import { VideoGif } from 'components/basic/VideoGif'
import { Type } from 'components/Type'

export const BestWayToWakeUp: FC<BestWayToWakeUpProps> = (props) => {
	const { ctaUrl = '/product/pod-cover' } = props
	return (
		<div className={styles.container}>
			<div className={styles.inner_container}>
				<div className={styles.video_container}>
					<VideoGif src={'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/Pod4-Front-View.mp4'} />
				</div>
				<Type.Headline2 as={'h2'}>The best way to wake up</Type.Headline2>
				<div className={styles.cta_button}>
					<Type.Body1>
						Each morning, you'll awaken naturally to a gentle vibration and temperature shift that gradually increases over five minutes. No more noisy alarms or disturbing your partner{' '}
					</Type.Body1>
				</div>
			</div>
		</div>
	)
}
